<div class="container-fluid">
  <div class="invoiceWrapper">
    <div class="row">
      <div class="col-lg-1"></div>
      <div class="col-lg-10">
        <div class="card">
          <div class="card-body">
            <div class="headerWrapper">
              <h4> Products</h4>
              <div class="buttonWrapper">
                <button *ngIf="addPermission === true" class="export-btn addproduct" mat-raised-button
                        (click)="openDialog()">
                    <i class="export-icon"></i>
                    ADD NEW
                </button>
                <button *ngIf="editPermission === true" class="btn btn-warning btn-sm"
                        (click)="editDialog(selectedIndex)"><i class="fa fa-pencil-square-o"
                                                               aria-hidden="true"></i>EDIT
                </button>
                <button *ngIf="deletePermission === true" class="btn btn-danger btn-sm"
                        (click)="deleteDialog(selectedIndex)"><i class="fa fa-trash" aria-hidden="true"></i>DELETE
                </button>
              </div>

            </div>
            <div class="customModal">
            </div>
            <table class="table table-bordered" *ngIf="viewPermission === true">
              <thead>
              <tr>
                <th class="col1">S.NO</th>
                <th class="col2">Code</th>
                <th class="col3">Name</th>
                <th class="col4">B.Part</th>
                <th class="col5">Implant</th>
                <th class="col6">Qty.</th>
                <th class="col7">Rate</th>
                <th class="col8">Discount</th>
                <th class="col9">Amount</th>
              </tr>
              </thead>
              <tbody>
              <tr rowspan=""
                  *ngFor="let in of products | slice: 0:10| paginate: { id: 'stockPageId', itemsPerPage: per_page, currentPage: current_page, totalItems: total_count}; let i = index "
                  (click)="selectRow(i)" [ngClass]="{'sel': i === selectedIndex }"
                  (dblclick)="editDialog(selectedIndex)" style="height: 36px;">
                <!-- <th scope="row">{{in.id}}</th> -->

                <td class="col10">{{in.id}}</td>
                <td class="col11">{{in.code}}</td>
                <td class="col12">{{in.name}}</td>
                <td class="col13">{{in.body_part_name}}</td>
                <td class="col14">{{in.implant_name}}</td>
                <td class="col15">{{in.quantity}}</td>
                <td class="col16">{{in.rate}}</td>
                <td class="col17">{{in.discount}}</td>
                <td class="col18">{{in.amount}}</td>
              </tr>
              </tbody>
            </table>
            <div class="footerWrapper row">
              <div class="col-lg-7 col-md-12 col-sm-12">

                <div class="input-group">
                  <select name="searchBy" [(ngModel)]="searchBy" data-show-content="true"
                          class="form-control border" (change)="getSearchValue()">
                    <option name="productsNo" value="0"> Search by Name</option>
                    <option name="productsNoCode" value="1"> Search by Code</option>
                    <option name="bodyNoName" value="2"> Search by Body Part</option>
                    <option name="implantNoName" value="3"> Search by Implant Type</option>
                  </select>

                  <input type="text" placeholder="Search" class="form-control" name="searchTxt" [(ngModel)]="searchTxt" [placeholder]="placeHolder">

                  <span class="input-group-text" (click)="doSearch()">
                      <i class="fa fa-search" aria-hidden="true"></i>
                  </span>
                  <span class="input-group-text" (click)="doRefresh()">
                      <i class="fa fa-refresh" aria-hidden="true"></i>
                  </span>
                    
                </div>
              </div>
              <div class="col-lg-5 col-md-12 col-sm-12">
                <app-common-page [id]="stockPageId" (pageChange)="doPaginate($event)">
                </app-common-page>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-1"></div>
      </div>
    </div>
  </div>
</div>
